export default "__VITE_ASSET__6b3f0cd1__"